<template>
    <div>
        <div>
            default-layout
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "default"
    }
</script>

<style scoped>

</style>